import React from 'react'

const StatusCards = ({ cardsData , className, cardsClass}) => {
  return (
    <div className={`w-full flex gap-4 ${className}`}>
     {
        cardsData.map((card , index) => (
            <div key={index} className={`flex flex-col gap-2 ${cardsClass} w-full bg-white p-4 rounded border border-mutedGray`}>
                <div className='flex flex-row items-center gap-2'>
                  <p className='text-3xl font-semibold text-primaryBlack'>
                    {card.count}
                  </p>
                  {(typeof card.percentage === 'number' && card.percentage >= 0) && (<p className='text-sm font-semibold text-web-blue flex gap-[1px] items-center'>
                    {card.percentage} <span className='text-[10px]'>%</span>
                  </p>)}
                </div>
                <p className='text-sm text-textGray'>
                    {card.title}
                </p>
            </div>
        ))
     }
    </div>
  )
}

export default StatusCards